var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.moviePath}},[_c('img',{attrs:{"src":_vm.posterImage,"alt":_vm.movie.title},on:{"error":_vm.imgPlaceHolder}})])}
var staticRenderFns = []

export { render, staticRenderFns }